import { SettingConst } from '../../types';

/**
 * Enables the Insider membership pause feature to an audience.
 */
export const INSIDER_MEMBERSHIP_PAUSE_ENABLED =
  'INSIDER_MEMBERSHIP_PAUSE_ENABLED' as SettingConst<
    'INSIDER_MEMBERSHIP_PAUSE_ENABLED',
    boolean,
    'RETAILER'
  >;
